export default "__VITE_ASSET__BtsrO84G__"